module.exports = __webpack_public_path__ + "10896f269436337ea4b9c0960fa671af.png";